import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import mixin from "./mixin.js";

Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#app')
Vue.mixin(mixin);
const vm = new Vue({
    el: "#app",
    router,
    // store,
    render: h => h(App),
    created () {
        // this.$store.commit("addRoute", lokalmixin.routes);
    }
}).$mount("#app");
global.vm = vm;